exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".md-errors-spacer {\n  min-height: 0 !important; }\n\nmd-chip {\n  cursor: pointer !important; }\n\n.md-media-sm {\n  cursor: pointer; }\n\n.md-cancel-button {\n  color: rgba(0, 0, 0, 0.87) !important; }\n", ""]);

// exports
